window.onload = function() {
    checkCookies();
  };
document.addEventListener('DOMContentLoaded', function() { 

  // Cookie helpers
  function setCookie(name, value) {
    document.cookie = name + '=' + value + '; path=/';
  }
  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }

  // UI logic for Produkter/Projekter
  function showProdukter() {
    // Show/hide elements for Produkter
    document.body.classList.add('show-produkter');
    document.body.classList.remove('show-projekter');
    // Add more UI logic here as needed
  }
  function showProjekter() {
    // Show/hide elements for Projekter
    document.body.classList.add('show-projekter');
    document.body.classList.remove('show-produkter');
    // Add more UI logic here as needed
  }

  // Modal logic
  let sverigeCustomer = document.querySelector('#sverige-customer');
  let cookieDecider = !sverigeCustomer;
  if (sverigeCustomer) deleteCookie('userType');

  // Button event listeners
  if (cookieDecider) {
    let btnProdukter = document.getElementById('pricePrivat');
    let btnProjekter = document.getElementById('priceB2B');
    if (btnProdukter) {
      btnProdukter.addEventListener('click', function() {
        setCookie('userType', 'produkter');
        checkCookies();
      });
    }
    if (btnProjekter) {
      btnProjekter.addEventListener('click', function() {
        setCookie('userType', 'projekter');
        checkCookies();
      });
    }
  }

  // Switch button logic
  let userTypeSwitch = document.querySelector('.custom-userType-btn');
  if (userTypeSwitch) {
    let modal = document.querySelector('.custom-price-modal');
    userTypeSwitch.addEventListener('click', function() {
      if (modal) modal.style.display = 'flex';
    });
  }

  // Logout logic
  let logoutBtn = document.querySelector('.logout-btn');
  if (logoutBtn) {
    logoutBtn.addEventListener('click', function() {
      deleteCookie('userType');
      checkCookies();
    });
  }

  // Main cookie check logic
  function checkCookies() {
    let userType = getCookie('userType');
    let userTypeSwitch = document.querySelector('.custom-userType-btn');
    let modal = document.querySelector('.custom-price-modal');
    if (userType) {
      if (userTypeSwitch) {
        userTypeSwitch.style.display = 'block';
        // Use the button with id pricePrivat or priceB2B based on userType
        let btnId = userType === 'produkter' ? 'pricePrivat' : (userType === 'projekter' ? 'priceB2B' : null);
        let btn = btnId ? document.getElementById(btnId) : null;
        if (btn && btn.getAttribute('data-content')) {
          userTypeSwitch.textContent = btn.getAttribute('data-content');
        } else {
          userTypeSwitch.textContent = userType;
        }
      }
      if (modal) modal.style.display = 'none';
      if (userType === 'produkter') {
        showProdukter();
      } else if (userType === 'projekter') {
        showProjekter();
      }
    } else {
      /* if (cookieDecider && modal) modal.style.display = 'flex';
      document.body.classList.remove('show-produkter', 'show-projekter'); */
    }
  }

    function complementaryDropdown() {
        // Custom product info dropdown
      let section = document.querySelector('.complementary-dropdown-section');

      if (section) {
        const btn = section.querySelector('.dropdown-initiate');
        const productList = section.querySelector('.horizontal-product-list');
        const maxHeight = section.getAttribute('data-recommendation-height');

        if (btn && productList) {
          btn.addEventListener('click', function() {
            if (section.classList.contains('open')) {
              // Restore previous maxHeight
              if (productList.dataset.prevMaxHeight !== undefined) {
                productList.style.maxHeight = productList.dataset.prevMaxHeight;
                delete productList.dataset.prevMaxHeight;
              } else {
                productList.style.maxHeight = '';
              }
              section.classList.remove('open');
              btn.classList.remove('open');
            } else {
              // Store current maxHeight before opening
              productList.dataset.prevMaxHeight = productList.style.maxHeight;
              productList.style.maxHeight = maxHeight + 'px';
              section.classList.add('open');
              btn.classList.add('open');
            }
          });
        }
      }
  }

  function addFooterIcons() {
    const footer = document.querySelector('.footer__wrapper');
    if (!footer) {
      console.log('Footer wrapper not found');
      return;
    }

    const phoneIcon = `<svg role="presentation" fill="none" focusable="false" stroke-width="1.5" width="18" height="18" class="{{ class | strip }}" viewBox="0 0 24 24">
        <path d="M7.102 7.137a2.628 2.628 0 0 0-3.895.421c-.14.192-.312.415-.531.691a4.843 4.843 0 0 0 .007 6.028c1.039 1.287 2.127 2.586 3.343 3.804 1.217 1.217 2.516 2.305 3.805 3.342 1.742 1.406 4.276 1.406 6.026.009.31-.249.554-.432.76-.583 1.237-.903 1.448-2.599.445-3.758a44.912 44.912 0 0 0-1.42-1.542c-.657-.695-1.789-.772-2.512-.144-.125.11-.287.257-.511.464-2-1.188-3.214-2.417-4.382-4.382.213-.226.36-.39.472-.517a1.827 1.827 0 0 0-.148-2.503c-.48-.448-.963-.897-1.459-1.33Z" fill="currentColor" fill-opacity="{% if settings.icon_style == 'duo' %}.12{% else %}0{% endif %}" stroke="currentColor" stroke-linejoin="round"/>
        <path d="M17.297 10.644a4.354 4.354 0 0 0-1.508-2.517 4.354 4.354 0 0 0-2.875-.994M22.59 9.77a9.824 9.824 0 0 0-3.405-5.678 9.828 9.828 0 0 0-6.494-2.246" stroke="currentColor" stroke-linecap="round"/>
      </svg>`;
    const mailIcon = `<svg role="presentation" fill="none" focusable="false" stroke-width="1.5" width="18" height="14" class="{{ class | strip }}" viewBox="0 0 18 14">
        <path clip-rule="evenodd" d="M1 2.5A1.5 1.5 0 0 1 2.5 1h13A1.5 1.5 0 0 1 17 2.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 1 11.5v-9Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="m16 2-5.61 4.506c-.82.659-1.96.659-2.78 0L2 2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>`;

    // Helper to insert icon before <a> tag
      function insertIconBeforeLabel(link, iconHTML) {
        const parent = link.parentNode;
        let prev = link.previousSibling;
        // Only proceed if previous sibling is a text node
        if (prev && prev.nodeType === Node.TEXT_NODE && prev.textContent.trim() !== '') {
          // Create icon span
          const iconSpan = document.createElement('span');
          iconSpan.innerHTML = iconHTML;
          iconSpan.style.marginRight = '5px';
          // Insert icon before the text node
          parent.insertBefore(iconSpan, prev);
        }
      }

      footer.querySelectorAll('a[href^="tel:"]').forEach(link => {
        insertIconBeforeLabel(link, phoneIcon);
      });

      footer.querySelectorAll('a[href^="mailto:"]').forEach(link => {
        insertIconBeforeLabel(link, mailIcon);
      });
    }
  

  // Check for cookies when the page loads
  window.onload = function() {
    checkCookies();
    setTimeout(function() {
      complementaryDropdown();
      addFooterIcons();
    }, 500);
  };


    //Custom drop function
    let produktudvikling = document.querySelector('.produktudvikling-drop img'),
    produktion = document.querySelector('.produktion-drop img'),
    raadgivning = document.querySelector('.raadgivning-drop img'),
    produktudviklingText = document.querySelector('.produktudvikling-d'),
    produktionText = document.querySelector('.produktion-d'),
    raadgivningText = document.querySelector('.raadgivning-d');

    if (produktudvikling && produktion && raadgivning) {
    produktudvikling.addEventListener('mouseenter', function(){
        produktionText.classList.remove('active-text');
        raadgivningText.classList.remove('active-text');
        produktudviklingText.classList.add('active-text');
    })
    produktudvikling.addEventListener('click', function(){
        produktionText.classList.remove('active-text');
        raadgivningText.classList.remove('active-text');
        produktudviklingText.classList.add('active-text');
    })

    produktion.addEventListener('mouseenter', function(){
        produktudviklingText.classList.remove('active-text');
        raadgivningText.classList.remove('active-text');
        produktionText.classList.add('active-text');
    })
    produktion.addEventListener('click', function(){
        produktudviklingText.classList.remove('active-text');
        raadgivningText.classList.remove('active-text');
        produktionText.classList.add('active-text');
    })

    raadgivning.addEventListener('mouseenter', function(){
        produktudviklingText.classList.remove('active-text');
        produktionText.classList.remove('active-text');
        raadgivningText.classList.add('active-text');
    })
    raadgivning.addEventListener('click', function(){
        produktudviklingText.classList.remove('active-text');
        produktionText.classList.remove('active-text');
        raadgivningText.classList.add('active-text');
    }) }

    // Custom contact for order function in cart page
    /* setTimeout(function(){
        let inputDestination = document.querySelector('.hidden-product-inputs');
     if (inputDestination) {
        let productSummary = document.querySelector('.order-summary__body'),
        products = productSummary.querySelectorAll('tr'),
        index = 0;
        products.forEach(function (product){
            index = index + 1;
            let title = product.querySelector('.line-item__info .reversed-link').textContent,
            quantity = product.querySelector('line-item-quantity input').value;
            let price;
            if (product.querySelector('.total-price-custom .money.withVat')) {
              price = product.querySelector('.total-price-custom .money.withVat').textContent;
            } else if (product.querySelector('.total-price-custom .money')) {
              price = product.querySelector('.total-price-custom .money').textContent;
            } else {
              price = product.querySelector('.hiddenPriceSverige').textContent;
            }
            let variant;
            if (product.querySelector('.custom-variant-title')) {
              variant = product.querySelector('.custom-variant-title').textContent;
            }
            let inputField = document.createElement('input');
            inputField.type = 'text';
            inputField.classList.add('input', 'is-floating');
            inputField.name = 'contact[produkt ' + index + ']';
            if (product.querySelector('.custom-variant-title')) {
              inputField.value = title + ' - Variant: '+ variant + ' - Antal: ' + quantity + ' - Pris: ' + price;
            } else {
              inputField.value = title + ' - Antal: ' + quantity + ' - Pris: ' + price;
            }
            inputDestination.appendChild(inputField);
        });
    }
    
      let userTypeCookie = getCookie('userType'),
      userTypeDestination = document.querySelector('.hidden-userType-input');
      let totalInputDestination = document.querySelector('.hidden-input.total-controls');
      let totalInput = document.createElement('input');
      totalInput.type = 'text';
      totalInput.classList.add('input', 'is-floating');
      totalInput.name = 'contact[total]';
      if (userTypeCookie && userTypeDestination) {
        let inputField = document.createElement('input');
        inputField.type = 'text';
        inputField.classList.add('input', 'is-floating');
        inputField.name = 'contact[bruger_type]';
        if (userTypeCookie === 'Privatkunde') {
          inputField.value = 'Privatkunde';
          userTypeDestination.appendChild(inputField);
          totalInput.value = document.querySelector('.custom-cart-total .currentStart').textContent;
          totalInputDestination.appendChild(totalInput);

        } else if (userTypeCookie === 'Erhvervskunde') {
          inputField.value = 'Erhvervskunde';
          userTypeDestination.appendChild(inputField);
          totalInput.value = document.querySelector('.custom-cart-total .money').textContent;
          totalInputDestination.appendChild(totalInput);
        }
        
          
      } 
    
    },500) */
    
    // Custom variant data and files swatches
    let variantPicker = document.querySelector('.product-info__variant-picker');
    if (variantPicker) {
        let variantOptions = variantPicker.querySelectorAll('label.block-swatch');
        variantOptions.forEach(function(variantOption){
            let textCheck = variantOption.querySelector('span').textContent;
            variantOption.addEventListener('click', function(){
                let dataLists = document.querySelectorAll('.variant-documents');
                dataLists.forEach(function(dataList){
                    let dataCheck = dataList.getAttribute('id');
                    dataList.classList.remove('active');
                    if (textCheck == dataCheck) {
                        dataList.classList.add('active');
                    }
                })
                let klimaList = document.querySelectorAll('.product-info__climate-impact_variant');
                if (klimaList) {
                    klimaList.forEach(function(klima){
                        let klimaCheck = klima.getAttribute('id');
                        klima.classList.remove('active');
                        if (textCheck == klimaCheck) {
                            klima.classList.add('active');
                        }
                    })
                };
            })
        })
    }

    let articleNav = document.querySelector('.custom-navigation-container');
  if (articleNav) {
    let navList = articleNav.querySelector('.custom-navigation-list');
    function createArticleNavigation() {
      const headings = document.querySelectorAll('.h2');
      headings.forEach((heading, idx) => {
        const navItem = document.createElement('button');
        navItem.textContent = heading.textContent;
        navItem.className = 'custom-nav-item';
        navItem.addEventListener('click', () => {
          const rect = heading.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const offset = rect.top + scrollTop - (window.innerHeight / 2) + (rect.height / 2);
          window.scrollTo({ top: offset, behavior: 'smooth' });
        });
        navList.appendChild(navItem);
      });
    }
    
    function setLeft() {
      const rect = proseIndicator.getBoundingClientRect();
      let proseX = rect.left + window.pageXOffset - 20; // Subtract 20px
      proseX = Math.max(proseX, 350); // Ensure a minimum of 350px
      let columns = document.querySelector('.custom-article-layout');
      if (columns) {
        columns.style.setProperty('grid-template-columns', `${proseX}px 1fr`);
      }
    }

    let proseIndicator = document.querySelector('.shopify-section--main-article .article-content');
    if (proseIndicator) {
      setLeft();
      window.addEventListener('resize', setLeft);
    }
    
    createArticleNavigation();
    
  }

  // Custom cases filtering
  let filterContainer = document.querySelector('.blog-filter-list');
  if (filterContainer) {
    let filterButtonList = filterContainer.querySelector('ul');
    let filterButtons = filterButtonList.querySelectorAll('li');
    let caseArticles = document.querySelectorAll('blog-post-card.blog-post-card');
    let mobileOpen = filterContainer.querySelector('.custom-filtering-headliner');
    
    // Helper functions for cookie handling
    function setCookie(name, value, minutes) {
      const d = new Date();
      d.setTime(d.getTime() + (minutes * 60 * 1000));
      document.cookie = `${name}=${encodeURIComponent(value)};expires=${d.toUTCString()};path=/`;
    }
    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : null;
    }

    // Array to store selected filter values
    let selectedFilters = [];

    // Function to filter case articles based on selected filters
    function filterCaseArticles() {
      caseArticles.forEach(function(article) {
        let badges = article.querySelectorAll('.badge');
        let badgeTexts = Array.from(badges).map(badge => badge.textContent.trim());
        // Show if any badge matches a selected filter, or if no filters are selected
        let show = selectedFilters.length === 0 || selectedFilters.some(filter => badgeTexts.includes(filter));
        article.style.display = show ? '' : 'none';
      });
    }

    // On load, restore selected filters from cookie
    const cookieVal = getCookie('selectedFilters');
    if (cookieVal) {
      try {
        selectedFilters = JSON.parse(cookieVal);
        filterButtons.forEach(function(button) {
          let filterVal = button.textContent.trim();
          if (selectedFilters.includes(filterVal)) {
            button.classList.add('selected');
          }
        });
      } catch (e) {
        selectedFilters = [];
      }
    }

    // Initial filter on page load
    filterCaseArticles();

    mobileOpen.addEventListener('click', function() {
      filterButtonList.classList.toggle('active');
    });

    filterButtons.forEach(function(button) {
      button.addEventListener('click', function(){
        let filterVal = button.textContent.trim();
        button.classList.toggle('selected');
        // Toggle filterVal in selectedFilters array
        let idx = selectedFilters.indexOf(filterVal);
        if (idx > -1) {
          selectedFilters.splice(idx, 1);
        } else {
          selectedFilters.push(filterVal);
        }
        // Save selectedFilters to cookie for 2 minutes
        setCookie('selectedFilters', JSON.stringify(selectedFilters), 5);
        filterCaseArticles();
        console.log('Selected Filters:', selectedFilters);
      });
    });

  }

   // Custom slide up animation for banner article
  document.querySelectorAll('.slide-up-banner.article-banner').forEach(section => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add('slide-up-visible');
          observer.disconnect();
        }
      });
    }, { threshold: 0.2 });

    observer.observe(section);
  });

  // Custom slide up animation for RTF
  document.querySelectorAll('.slide-up-section-rtf').forEach(section => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add('slide-up-visible');
          observer.disconnect();
        }
      });
    }, { threshold: 0.2 });

    observer.observe(section);
  });


  // Custom form styling
  const formContainer = document.querySelector('#app-embed');

  const formObserver = new MutationObserver((mutationsList, formObserver) => {
    const form = document.querySelector('shopify-forms-embed');
    if (form) {
      formObserver.disconnect();
      const shadow = form.shadowRoot;
      const sheet = new CSSStyleSheet();
      sheet.insertRule(`
        button[type="submit"] {
          border-radius: 60px!important;
          font-weight: 600!important;
        }
      `);

      shadow.adoptedStyleSheets.push(sheet);
      formContainer.classList.add('loaded');
    }
  });

  formObserver.observe(document.body, { childList: true, subtree: true });

  

});

